import { HOTLINE_INTERVIEW_STATUS_ACCEPT, HOTLINE_INTERVIEW_STATUS_COMPLETED, } from '@/feature/hotline/constant/interviewStatus';
/**
 * 相談日程確定判定 + 型ガード
 * @description 面談に関する情報が全てある + ステータスが受諾状態
 */
export const isScheduleFixedRequest = (requestData) => {
    const requestInterview = requestData === null || requestData === void 0 ? void 0 : requestData.hotline_request_interview;
    return (
    // 面談情報がある
    !!requestInterview &&
        // 面談情報があるか
        !!requestInterview.interviewed_from_at &&
        !!requestInterview.interviewed_to_at &&
        // 連絡先の情報があるか
        !!requestInterview.phone1 &&
        !!requestInterview.phone2 &&
        !!requestInterview.phone3 &&
        // ステータスが受諾・完了か
        (requestInterview.status === HOTLINE_INTERVIEW_STATUS_ACCEPT.value ||
            requestInterview.status === HOTLINE_INTERVIEW_STATUS_COMPLETED.value));
};
